/** SetpageHold.jsx 와 동일한 용어/값 — coins_data_hold 일괄 수정용 */

export const HOLD_BULK_TABLE = "coins_data_hold";
export const HOLD_BULK_VERSION_LABEL = "홀드버전";

const ON_OFF = [
  { value: "1", label: "켜짐 (1)" },
  { value: "0", label: "꺼짐 (0)" },
];

const UT_KINPOINT = [
  { value: "ut", label: "시그널" },
  { value: "kinpoint", label: "킨포인트" },
];

const HEDGE_MODE = [
  ...UT_KINPOINT,
  { value: "none", label: "미적용" },
  { value: "losscut", label: "손절적용" },
];

const FULL_MODE = [
  { value: "extension", label: "즉시진입모드" },
  { value: "original", label: "변곡진입모드" },
];

const FIRST_ENTRY_MODE = [
  { value: "immediate", label: "즉시" },
  { value: "nine_am", label: "09시 모드" },
];

const ESCAPE_MODE = [
  { value: "off", label: "미적용" },
  { value: "escape_long", label: "탈출모드-롱" },
  { value: "escape_short", label: "탈출모드-숏" },
];

const BOTH_MODE = [
  { value: "single", label: "single mode" },
  { value: "double", label: "double mode" },
];

const CANDLE = [
  { value: "5m", label: "5 분봉" },
  { value: "15m", label: "15 분봉" },
  { value: "30m", label: "30 분봉" },
  { value: "1h", label: "1 시간봉" },
  { value: "4h", label: "4 시간봉" },
  { value: "6h", label: "6 시간봉" },
  { value: "12h", label: "12 시간봉" },
  { value: "1d", label: "1 일봉" },
  { value: "3d", label: "3 일봉" },
  { value: "1w", label: "1 주봉" },
];

const CANDLE_TYPE = [
  { value: "haikin", label: "하이킨아시" },
  { value: "normal", label: "일반봉" },
];

const SIGNAL_CHECKING = [
  { value: "-1", label: "발생" },
  { value: "-2", label: "확정" },
];

const ABLE_DISABLE = [
  { value: "able", label: "적용" },
  { value: "disable", label: "미적용" },
];

const ENTRY_STANDARD = [
  { value: "ut", label: "시그널" },
  { value: "candle", label: "캔들" },
  { value: "ema", label: "EMA" },
  { value: "disable", label: "미적용" },
];

const HOLD_PRESERVE = [
  { value: "disable", label: "수수료보전" },
  { value: "able", label: "수익보전" },
];

const TRIGGER_MODE = [
  { value: "no", label: "미적용" },
  { value: "ratio", label: "비율" },
  { value: "price", label: "가격" },
];

const DIRECTION = [
  { value: "long", label: "롱" },
  { value: "short", label: "숏" },
  { value: "auto", label: "자동전환" },
];

const CIRCLE_BENEFIT_MODE = [
  { value: "absolute", label: "절대" },
  { value: "signal", label: "신호기준" },
];

const HEDGE_CONTINUE = [
  { value: "no", label: "미적용" },
  { value: "ok", label: "적용" },
];

const TOTAL_CONTINUE_DIR = [
  { value: "both", label: "양방향" },
  { value: "long", label: "롱" },
  { value: "short", label: "숏" },
];

const CIRCLE_HEDGE_MODE = [
  ...UT_KINPOINT,
  { value: "none", label: "미적용" },
  { value: "losscut", label: "손절적용" },
];

const CIRCLE_MODE = [
  { value: "entry", label: "entry" },
  { value: "disable", label: "disable" },
];

/** @type {Array<{ column: string, label: string, group: string, inputType?: string, options?: Array<{value:string,label:string}> }>} */
export const HOLD_BULK_FIELDS = [
  { column: "uid", label: "UID", group: "계정/심볼", inputType: "text" },
  { column: "symbol", label: "심볼", group: "계정/심볼", inputType: "text" },
  { column: "normal_selected", label: "심볼 선택 여부", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "trade_start", label: "매매 시작", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "restart", label: "재시작", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "current_symbol_stop", label: "심볼 일시정지", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "current_symbol_cancle", label: "심볼 취소", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "long_entry", label: "롱 레그 상태", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "short_entry", label: "숏 레그 상태", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "continue_entry", label: "연속 진입(즉시)", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "add_position", label: "추가진입/헷지 단계", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "both_mode", label: "Single/Double 모드", group: "매매 상태", inputType: "select", options: BOTH_MODE },
  { column: "direction", label: "진입 방향 선택", group: "매매 상태", inputType: "select", options: DIRECTION },
  { column: "entry_mode", label: "진입기준", group: "Basic setting", inputType: "select", options: UT_KINPOINT },
  { column: "hedge_mode", label: "헷지기준", group: "Basic setting", inputType: "select", options: HEDGE_MODE },
  { column: "full_mode", label: "진입모드", group: "Basic setting", inputType: "select", options: FULL_MODE },
  { column: "first_entry_mode", label: "첫진입 시각", group: "Basic setting", inputType: "select", options: FIRST_ENTRY_MODE },
  { column: "escape_mode", label: "탈출모드", group: "Basic setting", inputType: "select", options: ESCAPE_MODE },
  {
    column: "escape_last_long_entry_px",
    label: "탈출 최고가(롱 기준가)",
    group: "Basic setting",
    inputType: "escape_px",
  },
  {
    column: "escape_last_short_entry_px",
    label: "탈출 최저가(숏 기준가)",
    group: "Basic setting",
    inputType: "escape_px",
  },
  {
    column: "escape_auto_refresh_gap_pct",
    label: "탈출 자동갱신 이격(%)",
    group: "Basic setting",
    inputType: "number",
  },
  {
    column: "escape_hedge_losscut_pct",
    label: "탈출헷지손절률(%)",
    group: "Basic setting",
    inputType: "number",
  },
  {
    column: "escape_same_bar_entry_extra",
    label: "탈출 동일봉 추가진입(회)",
    group: "Basic setting",
    inputType: "number",
  },
  { column: "entry_candle", label: "진입 기준봉", group: "Basic setting", inputType: "select", options: CANDLE },
  { column: "hedge_candle", label: "헷지 기준봉", group: "Basic setting", inputType: "select", options: CANDLE },
  { column: "candle_type_entry", label: "진입/헷지 기준 캔들", group: "Basic setting", inputType: "select", options: CANDLE_TYPE },
  { column: "candle_type_close", label: "익절 기준 캔들", group: "Basic setting", inputType: "select", options: CANDLE_TYPE },
  { column: "sensitivity", label: "LONG Sensitivity (진입)", group: "Basic setting", inputType: "number" },
  { column: "atr_period", label: "LONG ATR Period (진입)", group: "Basic setting", inputType: "number" },
  { column: "sensitivity_short", label: "SHORT Sensitivity (진입)", group: "Basic setting", inputType: "number" },
  { column: "atr_period_short", label: "SHORT ATR Period (진입)", group: "Basic setting", inputType: "number" },
  { column: "entry_checking", label: "진입 기준 신호", group: "Basic setting", inputType: "select", options: SIGNAL_CHECKING },
  { column: "hedge_checking", label: "헷지 기준 신호", group: "Basic setting", inputType: "select", options: SIGNAL_CHECKING },
  { column: "entry_hold_ratio", label: "진입 보전 발동률(%)", group: "Basic setting", inputType: "number" },
  { column: "entry_hold_mode", label: "진입 보전 모드", group: "Basic setting", inputType: "select", options: HOLD_PRESERVE },
  { column: "hedge_hold_ratio", label: "헷지 보전 발동률(%)", group: "Basic setting", inputType: "number" },
  { column: "hedge_hold_mode", label: "헷지 보전 모드", group: "Basic setting", inputType: "select", options: HOLD_PRESERVE },
  { column: "trigger_mode", label: "트리거 기준", group: "Basic setting", inputType: "select", options: TRIGGER_MODE },
  { column: "trigger_ratio", label: "헷지트리거(%)", group: "Basic setting", inputType: "number" },
  { column: "entry_continue", label: "연속 진입", group: "Basic setting", inputType: "select", options: ABLE_DISABLE },
  { column: "entry_standard", label: "보조 모드", group: "Support setting", inputType: "select", options: ENTRY_STANDARD },
  { column: "ema_standard", label: "EMA 기준봉갯수", group: "Support setting", inputType: "number" },
  { column: "ema_losscut", label: "EMA 손절적용", group: "Support setting", inputType: "select", options: [{ value: "no", label: "미적용" }, { value: "apply", label: "적용" }] },
  { column: "ema_hedge_gap_ratio", label: "EMA 헷지 이격(%)", group: "Support setting", inputType: "number" },
  { column: "candle_standard", label: "보조 시간봉", group: "Support setting", inputType: "select", options: CANDLE },
  { column: "candle_type_standard", label: "보조 신호 기준", group: "Support setting", inputType: "select", options: CANDLE_TYPE },
  { column: "sensitivity_standard", label: "보조 Sensitivity", group: "Support setting", inputType: "number" },
  { column: "atr_period_standard", label: "보조 ATR Period", group: "Support setting", inputType: "number" },
  { column: "entry_standard_2nd", label: "2nd 보조 모드", group: "Support setting", inputType: "select", options: ENTRY_STANDARD },
  { column: "ema_standard_2nd", label: "2nd EMA 기준봉갯수", group: "Support setting", inputType: "number" },
  { column: "candle_standard_2nd", label: "2nd 보조 시간봉", group: "Support setting", inputType: "select", options: CANDLE },
  { column: "candle_type_standard_2nd", label: "2nd 신호 기준", group: "Support setting", inputType: "select", options: CANDLE_TYPE },
  { column: "sensitivity_standard_2nd", label: "2nd 보조 Sensitivity", group: "Support setting", inputType: "number" },
  { column: "atr_period_standard_2nd", label: "2nd 보조 ATR Period", group: "Support setting", inputType: "number" },
  { column: "circle_entry_mode", label: "순환매 진입 기준", group: "Circle setting", inputType: "select", options: UT_KINPOINT },
  { column: "circle_hedge_mode", label: "순환매 헷지 기준", group: "Circle setting", inputType: "select", options: CIRCLE_HEDGE_MODE },
  { column: "circle_entry_candle", label: "순환매 진입 기준봉", group: "Circle setting", inputType: "select", options: CANDLE },
  { column: "circle_hedge_candle", label: "순환매 헷지 기준봉", group: "Circle setting", inputType: "select", options: CANDLE },
  { column: "hedge_out_candle", label: "헷지 정리 기준봉", group: "Circle setting", inputType: "select", options: CANDLE },
  { column: "candle_type_circle_entry", label: "순환매 진입/헷지 캔들", group: "Circle setting", inputType: "select", options: CANDLE_TYPE },
  { column: "circle_entry_checking", label: "순환매 진입 기준 신호", group: "Circle setting", inputType: "select", options: SIGNAL_CHECKING },
  { column: "circle_hedge_checking", label: "순환매 헷지 기준 신호", group: "Circle setting", inputType: "select", options: SIGNAL_CHECKING },
  { column: "hedge_out_checking", label: "순환매 헷지 정리 신호", group: "Circle setting", inputType: "select", options: SIGNAL_CHECKING },
  { column: "circle_rate", label: "순환매 비율(%)", group: "Circle setting", inputType: "number" },
  { column: "circle_rate_interval", label: "순환매 기준 간격(%)", group: "Circle setting", inputType: "number" },
  { column: "circle_mode", label: "순환매 모드", group: "Circle setting", inputType: "select", options: CIRCLE_MODE },
  { column: "circle_benefit_mode", label: "순환매 익절기준 모드", group: "Circle benefit setting", inputType: "select", options: CIRCLE_BENEFIT_MODE },
  { column: "circle_close_mode", label: "순환매 익절 기준", group: "Circle benefit setting", inputType: "select", options: UT_KINPOINT },
  { column: "circle_candle", label: "순환매 익절기준봉", group: "Circle benefit setting", inputType: "select", options: CANDLE },
  { column: "candle_type_circle", label: "순환매 익절 기준 캔들", group: "Circle benefit setting", inputType: "select", options: CANDLE_TYPE },
  { column: "circle_checking", label: "순환매 익절 기준 신호", group: "Circle benefit setting", inputType: "select", options: SIGNAL_CHECKING },
  { column: "close_mode", label: "단일 익절 기준", group: "Close benefit setting", inputType: "select", options: UT_KINPOINT },
  { column: "close_candle", label: "익절 기준봉", group: "Close benefit setting", inputType: "select", options: CANDLE },
  { column: "close_checking", label: "익절 기준 신호", group: "Close benefit setting", inputType: "select", options: SIGNAL_CHECKING },
  { column: "single_tp_continue_mode", label: "익절 후 연속 진입", group: "Close benefit setting", inputType: "select", options: ABLE_DISABLE },
  { column: "leverage_info", label: "Set Leverage", group: "레버리지/진입", inputType: "number" },
  { column: "benefit_ratio", label: "최소 익절률(%)", group: "레버리지/진입", inputType: "number" },
  { column: "entry_usdt_1", label: "진입 USDT", group: "레버리지/진입", inputType: "number" },
  { column: "welfare_mode", label: "복리 모드 선택", group: "레버리지/진입", inputType: "select", options: ABLE_DISABLE },
  { column: "welfare_ratio", label: "복리 진입 비율(%)", group: "레버리지/진입", inputType: "number" },
  { column: "hedge_continue", label: "헷지 연결 포지션", group: "레버리지/진입", inputType: "select", options: HEDGE_CONTINUE },
  { column: "double_benefit", label: "더블익절설정(%)", group: "더블/종합익절", inputType: "number" },
  { column: "double_continue", label: "더블연속모드", group: "더블/종합익절", inputType: "select", options: ABLE_DISABLE },
  { column: "double_benefit_start", label: "더블익절 시작", group: "더블/종합익절", inputType: "boolean", options: ON_OFF },
  { column: "total_benefit_usdt", label: "종합 익절 셋팅(%)", group: "더블/종합익절", inputType: "number" },
  { column: "total_benefit_count", label: "종합 익절 목표 횟수", group: "더블/종합익절", inputType: "number" },
  { column: "total_current_count", label: "종합 익절 현재 횟수", group: "더블/종합익절", inputType: "number" },
  { column: "total_continue_mode", label: "종합 익절 연속 모드", group: "더블/종합익절", inputType: "select", options: ABLE_DISABLE },
  { column: "total_continue_direction", label: "연속 모드 시 진행 방향", group: "더블/종합익절", inputType: "select", options: TOTAL_CONTINUE_DIR },
  { column: "total_benefit_start", label: "종합익절 구동", group: "더블/종합익절", inputType: "boolean", options: ON_OFF },
  { column: "entry_price", label: "진입가(추적)", group: "가격/PNL 상태", inputType: "number" },
  { column: "hedge_price", label: "헷지가(추적)", group: "가격/PNL 상태", inputType: "number" },
  { column: "compare_hedge_price", label: "순환 기준가", group: "가격/PNL 상태", inputType: "number" },
  { column: "totalpnl", label: "RealizedPnL", group: "가격/PNL 상태", inputType: "number" },
  { column: "totalpnl_subtotal", label: "RealizedPnL 누적", group: "가격/PNL 상태", inputType: "number" },
  { column: "double_pnl", label: "더블 현재수익(USDT)", group: "가격/PNL 상태", inputType: "number" },
  { column: "current_balance", label: "현재 잔고(USDT)", group: "가격/PNL 상태", inputType: "number" },
  { column: "current_coin_clear", label: "현재 코인 정리", group: "정리 플래그", inputType: "boolean", options: ON_OFF },
  { column: "all_coin_clear", label: "전체 코인 정리", group: "정리 플래그", inputType: "boolean", options: ON_OFF },
  { column: "reset_coin_clear", label: "리셋 코인 정리", group: "정리 플래그", inputType: "boolean", options: ON_OFF },
  { column: "double_coin_clear", label: "더블 코인 정리", group: "정리 플래그", inputType: "boolean", options: ON_OFF },
  { column: "restrict_enabled", label: "진입 제한 사용", group: "진입 제한", inputType: "boolean", options: ON_OFF },
];

export const HOLD_FIELD_MAP = Object.fromEntries(HOLD_BULK_FIELDS.map((field) => [field.column, field]));

export const HOLD_BULK_GROUPS = [...new Set(HOLD_BULK_FIELDS.map((field) => field.group))];

export function getHoldFieldLabel(column) {
  return HOLD_FIELD_MAP[column]?.label || column;
}

export function getHoldFieldMeta(column) {
  return HOLD_FIELD_MAP[column] || { column, label: column, group: "기타", inputType: "text" };
}

export function formatHoldDisplayValue(column, rawValue) {
  if (rawValue === null || rawValue === undefined) {
    return "NULL";
  }

  const field = HOLD_FIELD_MAP[column];
  if (!field) {
    return String(rawValue);
  }

  if (field.options) {
    const matched = field.options.find((option) => String(option.value) === String(rawValue));
    if (matched) {
      return matched.label;
    }
  }

  return String(rawValue);
}

export function getFilterOperatorsForField(column) {
  const field = HOLD_FIELD_MAP[column];
  if (!field) {
    return [
      { value: "=", label: "같음 (=)" },
      { value: "!=", label: "다름 (!=)" },
      { value: "LIKE", label: "포함 (LIKE)" },
      { value: "IN", label: "목록 (IN)" },
      { value: "IS NULL", label: "비어 있음" },
      { value: "IS NOT NULL", label: "값 있음" },
    ];
  }

  if (field.inputType === "number" || field.inputType === "escape_px") {
    return [
      { value: "=", label: "같음 (=)" },
      { value: "!=", label: "다름 (!=)" },
      { value: ">", label: "큼 (>)" },
      { value: "<", label: "작음 (<)" },
      { value: ">=", label: "이상 (>=)" },
      { value: "<=", label: "이하 (<=)" },
      { value: "IS NULL", label: "비어 있음" },
    ];
  }

  if (field.inputType === "boolean" || field.inputType === "select") {
    return [
      { value: "=", label: "같음 (=)" },
      { value: "!=", label: "다름 (!=)" },
      { value: "IS NULL", label: "비어 있음" },
      { value: "IS NOT NULL", label: "값 있음" },
    ];
  }

  return [
    { value: "=", label: "같음 (=)" },
    { value: "!=", label: "다름 (!=)" },
    { value: "LIKE", label: "포함 (LIKE)" },
    { value: "IN", label: "목록 (IN, 쉼표 구분)" },
    { value: "IS NULL", label: "비어 있음" },
    { value: "IS NOT NULL", label: "값 있음" },
  ];
}
